"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_icons_1 = require("@grandlinex/react-icons");
function default_1({ name, size, width, height }) {
    return (0, react_icons_1.getIcon)(name)({
        size,
        width,
        height,
    });
}
exports.default = default_1;
